import React, { Component } from 'react'
import FeatureManager from 'scripts/lib/FeatureManager'
import queryString from 'querystring'

class FeatureFlags extends Component {
  handleClick = (evt) => {
    FeatureManager.setFeature(evt.target.id, evt.target.checked)
  }

  mapFeatureFlags(feature, index) {
    let checked = FeatureManager.getFeature(feature)
    return <li key={feature}>
      <input type="checkbox" id={feature} onChange={this.handleClick} defaultChecked={checked}/>
      <label>{feature}</label>
    </li>
  }

  isMenuActivated = () => {
    if (typeof location === 'undefined') { return false }
    const query = location.search.substring(1)
    const qs = queryString.parse(query)
    return (qs && qs.internal_set_features) ? JSON.parse(qs.internal_set_features.toLowerCase()) : false
  }

  render() {
    return (this.isMenuActivated()
      ? <div className="feature-flags-overlay flex flex-center-horizontal">
        <div className="feature-flags">
          <h1>Feature Selection</h1>
          <ul>
            {FeatureManager.ALLFEATURES.map(this.mapFeatureFlags, this)}
          </ul>
        </div>
      </div> : null
    )
  }
}

export default FeatureFlags



// WEBPACK FOOTER //
// ./assets/js/components/static/feature_flags.jsx